var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#151521"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8L32 12.1447L30.181 27.5395L20 33L9.819 27.5395L8 12.1447L20 8ZM20 10.7632L12.4932 27.0789H15.2896L16.7964 23.4211H23.1765L24.6833 27.0789H27.4661L20 10.7632ZM22.1991 21.1579H17.8145L20 16.0658L22.1991 21.1579Z",
    fill: "#151521"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.f40dc7ebbe899ffbeae95bfe90303777.svg";
export { ForwardRef as ReactComponent };